import { Controller } from 'stimulus'
import Rails from '@rails/ujs'
import { useDispatch } from 'stimulus-use'

const maxPollingRetries = 60
const pollingInterval = 5000

export default class extends Controller {
  static targets = ['selectAll', 'externalReports']

  initialize() {
    useDispatch(this)
  }

  connect() {
    this._pollingRetries = 0
    this._timeout = null
    this.fetchReports()
  }

  disconnect() {
    this.stopPollingTimeout()
  }

  fetchReports(page) {
    let formData = $('form').serialize()

    if (page) { formData = formData + '&' + page }

    Rails.ajax({
      type: 'get',
      url: '/reports',
      data: formData,
      dataType: 'script',
      success: () => {
        const externalProcessingReports = document.querySelectorAll('.external-report-processing')

        if (externalProcessingReports.length > 0) {
          this.startLegacyReportsPolling()
        }
      }
    })
  }

  onDeleteSuccess(event) {
    const id = event.target.dataset.referenceId.split('-')[2]
    const element = $(`#report_${id}`)

    element.fadeOut(() => {
      const checkbox = $(`#report-list-item-${id}`)[0]
      if (checkbox.checked) { checkbox.click() }
      setTimeout(() => element.remove(), 0)
      setTimeout(() => this.dispatch('onDeleteSuccess'), 1)
    })
  }

  onDeleteFailure(event) {
    alert('The delete could not be completed.')
  }

  handleNewPage(event) {
    event.preventDefault()
    const href = event.currentTarget.href
    this.fetchReports(href.substr(href.search('page'), href.length))
  }

  startLegacyReportsPolling() {
    this._pollingRetries = 0
    this.stopPollingTimeout()
    this.startPollingTimeout()
  }

  startPollingTimeout() {
    this._timeout = setTimeout(() => this.fetchExternalReportsStatus(), pollingInterval)
  }

  stopPollingTimeout() {
    clearTimeout(this._timeout)
  }

  fetchExternalReportsStatus() {
    const externalReportsElements = document.querySelectorAll('.external-report, .external-report-processing')
    const externalReports = { ids: [] }

    externalReportsElements.forEach(item => {
      externalReports.ids.push(item.id.split('_')[1])
    })

    if (externalReports.ids.length > 0 && this._pollingRetries < maxPollingRetries) {
      this._pollingRetries += 1

      Rails.ajax({
        type: 'get',
        url: '/external_reports',
        data: $.param(externalReports),
        dataType: 'json',
        complete: () => this.startPollingTimeout(),
        error: () => console.log('Something went wrong')
      })
    }
  }

  // Action used to refresh page when legacy report is generated.
  // Specifically generated by clicking "save as" on the edit report modal
  // (for legacy reports; Legacy reports refers to the ones created through the ember app).
  reloadPage(event) {
    location.reload()
  }
}
